export default __webpack_public_path__ + "static/media/flag-33x40px.0eee73ec.svg";